<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '实施文件',path: '/system/enforceFile'}"></Title>
    <div style="margin: 10px auto;">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px;">
          <el-col :span="4">
            <el-input v-model="qparam.userName" placeholder="上传人名字"></el-input>
          </el-col>
          <el-col :span="6">
            <el-input v-model="qparam.enforceName" placeholder="材料名称"></el-input>
          </el-col>
          <el-col :span="8">
            <el-date-picker
              v-model="applyTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px; margin-left: 10px;">
          <el-col :span="10">
            <el-input v-model="qparam.projectName" placeholder="项目名称"></el-input>
          </el-col>
          <el-col :span="6" style="float: right">
            <el-button icon="el-icon-refresh-left" type="primary" @click="resetQparam">重置</el-button>
            <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div style="margin: 10px auto;  ">
      <el-card class="box-card" style="min-height: 650px;">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="enforceName" label="实施材料名称"></el-table-column>
          <el-table-column prop="projectName" label="项目名称"></el-table-column>
          <el-table-column prop="enforceUpTime" label="上传时间"></el-table-column>
          <el-table-column prop="userName" label="上传人"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="handleDetail(scope.$index, scope.row)">查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 详情弹框 -->
        <el-dialog
            custom-class="no-padding-dialog no-margin-dialog"
            title="实施文件归档详情"
            :visible.sync="showDetailDialog"
            width="100%"
            :before-close="handleDialogClose">
          <!-- 详情组件 -->
          <EnforceDetail :query="selectedQuery" />
        </el-dialog>
        <div style="margin: 40px auto; width: 30%;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentPageChangeEvent"
            :current-page="qparam.current"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex';
import {requestEnforceFile} from "@/api";
import Title from "../../Title";
import EnforceDetail from "@/components/item/enforce/EnforceDetail.vue";
import {uuid} from "@/util";

export default {
  name: "AllApply",
  components: {EnforceDetail, Title},
  data() {
    return {
      uuid: "",
      tableData: [],
      totalElements: 0,
      qparam: {
        current: 1,
        size: 10,
        userName: "",
        enforceName: "",
        projectName: ""
      },
      apply: {},
      applyTime: [],
      detailShow: false,
      projectId: "",

      buttonArray : [{
        type: 'primary',
        title: '导出数据',
        method: 'exportApply',
        disabled: false,
      }],
      showDetailDialog: false, // 控制弹框显示
      selectedQuery: {},       // 存储当前选中行的参数
      dataList: [],            // 列表数据

    }
  },
  computed: {
    ...mapState(['flowData'])
  },
  methods: {

    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.initTableData()
    },
    resetQparam() {
      this.applyTime = []
      this.qparam.userName = ""
      this.qparam.projectName = ""
      this.qparam.enforceName = ""
      this.initTableData()
    },
    handleDetail(index, row) {
      this.selectedQuery = {
        applyId: row.applyId,
        applyServiceId: row.applyServiceId,
        applyType: row.applyType,
      }
      this.showDetailDialog = true;
      this.uuid = uuid();
    },
    handleDialogClose() {
      this.selectedQuery = {};
      this.showDetailDialog = false;
    },
    currentPageChangeEvent(currentPage) {
      this.qparam.current = currentPage;
      this.initTableData()
    },
    async search() {
      this.qparam.current = 1;
      await this.initTableData()
    },
    async initTableData() {
      this.qparam.startTime = this.applyTime[0]
      this.qparam.endTime = this.applyTime[1]
      const res = await requestEnforceFile(this.qparam);
      if (res.code === 200) {
        this.totalElements = res.total;
        this.tableData = res.rows
      } else {
        this.$message.error(res.msg)
      }
    }
  },
  created() {
    this.initTableData()
  }
}
</script>

<style scoped>
::v-deep .no-padding-dialog .el-dialog__body {
  padding: 0;
  margin-top: 0 !important;
}
::v-deep .no-margin-dialog {
  margin-top: 0 !important;
}
</style>
